<template>
    <TxtPage>
      
      <div slot="return-content" class="btn-return">
        <router-link :to="{ name: 'Acteurs' }" >
          <img src="../../assets/arrow.svg" />
        </router-link>
      </div>
      
      <div slot="left-content" class="spacer-content">
        <div class="title text-center text-uppercase text-light">Une idée, deux architectes, une structure commune</div>
        <div class="line"></div>
        <div class="text text-center ">
          DVVD, agence d’architecture, d’ingénierie et de design challenge l’enveloppe, la structure, les espaces partagés pour qu’ils révèlent le projet et s’intègrent au quartier. DATA, agence d’architecture se présente comme une plateforme de recherche pour favoriser l’exploitation et l’émergence de nouvelles typologies de construction. 
        </div>
        <div class="les-architectes">
            
            <div class="architecte">
                <img src="../../assets/archi-colin.jpg" class="img-fluid portrait"/> 
                <div class="text text-center">
                  Colin Reynier, <span class="d-block"><strong>DATA Architectes</strong></span>
                </div>
                <div class="text text-center">
                  <i>
                    Nous avons pris le parti d’imaginer cette nouvelle résidence du XIIIe arrondissement de Paris comme un lieux du « vivre ensemble » dans lequel chaque fonction, chaque composante, chaque usage et finalement chaque personne trouve sa place dans une combinaison innovante, harmonieuse et durable.
                  </i>
                </div>
              </div>
              
            <div class="architecte">
                <img src="../../assets/archi-daniel.jpg" class="img-fluid portrait"/> 
                <div class="text text-center">
                  Daniel Vaniche, <span class="d-block"><strong>DVVD</strong></span>
                </div>
                <div class="text text-center">
                  <i>
                    Le bâtiment sera conçu comme une structure capable d’accueillir le changement et l’évolutivité, propres aux usages de notre temps. Un positionnement fort face aux enjeux de l’architecture durable. Les logements peuvent se déployer au-delà de l’espace classique pour profiter d’un volume généreux ou d’une surface additionnelle.
                  </i>
                </div>
              </div>
              
          </div>
          
        <div class="btn-scroll"><img src="../../assets/scroll.svg" /></div>
        
        <router-link :to="{ name: 'Acteurs' }" class="btn-return">
          <img src="../../assets/arrow.svg" />
        </router-link>
        
      </div>
    
      <div slot="right-content">
        <img src="../../assets/pers-mot-des-architectes.jpg" class="cover-center"/>
      </div>
    
  </TxtPage>
</template>

<style lang="scss" scoped>
  .les-architectes {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between !important;
    .architecte {
      width: 45%;
        @media(min-width: 992px) {
          width: inherit;
        }
        .portrait {
          margin-bottom: 20px;
          margin-top: 40px;
        }
    }
  }
  
  .cover-center {
    @media (min-width: 992px) {
      -o-object-position: 200px -200px !important;
      object-position: 200px -200px !important;
    }
  }
  
  .line {
    margin: 0 auto 40px auto !important;
  }
  
</style>

<script>
// @ is an alias to /src

import TxtPage from '@/components/TxtPage.vue';

export default {
  name: 'Architectes',
  components: {
    TxtPage
  },
  data: () => {
      
        return { 
            
        };
    },
  
}
</script>